import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { UliCreationFacade } from './uli-creation.facade';
import { setInitialStoreState } from '../../../../../../common/utils';
import { Injectable } from '@angular/core';
import { filter, take } from 'rxjs/operators';
import { HubContextFacade } from '../../../../administration/hub/context/hub-context.facade';
import { HubBrief } from '../../../../administration/hub/models/hub.model';

@Injectable({
  providedIn: 'root',
})
export class UliCreationGuard {
  constructor(private uliCreationFacade: UliCreationFacade, private hubContextFacade: HubContextFacade) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    this.hubContextFacade.selectedHub$.pipe(filter(Boolean), take(1)).subscribe((hub: HubBrief) => {
      this.uliCreationFacade.getCompartments(hub?.id);
      this.uliCreationFacade.getDefaultHubTruckMapping(hub?.id);
      this.uliCreationFacade.getHubTruckMapping(hub?.id);
    });

    return of(true);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.uliCreationFacade);
  }
}
